<div class="snackbar-content">
  <mat-icon [svgIcon]="icon()"></mat-icon>
  <span>{{ data.message }}</span>
</div>
